import { useLocation } from "react-router-dom";

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange
}) => {

    const location = useLocation();
    if (!totalItems || totalItems <= itemsPerPage) return null;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        // <div className="pagination">
        <div  className={`pagination ${
            location.pathname === "/sales-by-display"
            ? "pagination-sales-by-display"
            // : location.pathname === "/manage-sales"
            // ? "pagination-sales"
            : ""
        }`}>
            {/* {Array.from({ length: totalPages }, (_, index) => (
            <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={currentPage === index + 1 ? 'active' : ''}
            >
                {index + 1}
            </button>
            ))} */}
            <button
                disabled={currentPage === 1}
                onClick={() => onPageChange(1)}
                style={{paddingRight: "0px"}}
            >
                « First
            </button>

            <button
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
                ‹ Prev
            </button>

            {/* Page Numbers */}
            {(() => {
                let start = Math.max(1, currentPage - 3);
                let end = Math.min(totalPages, start + 6);

                if (end - start < 6) {
                start = Math.max(1, end - 6);
                }

                return Array.from({ length: end - start + 1 }, (_, i) => {
                const pageNum = start + i;
                return (
                    <button
                    key={pageNum}
                    onClick={() => onPageChange(pageNum)}
                    className={currentPage === pageNum ? "active" : ""}
                    >
                    {pageNum}
                    </button>
                );
                });
            })()}

            <button
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                style={{paddingRight: "0px"}}
            >
                Next ›
            </button>

            <button
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(totalPages)}
            >
                Last »
            </button>
        </div>
    );
};
export default Pagination;
